import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { CommonService } from 'src/providers/common';
import { LoadingController, ToastController, ModalController, PopoverController, Platform } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { Payment } from 'src/providers/payment';
import { PopupalertPage } from '../popupalert/popupalert.page'
import { AddCall } from 'src/providers/addvCall';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}
@Component({
  selector: 'app-booking-conf',
  templateUrl: './booking-conf.page.html',
  styleUrls: ['./booking-conf.page.scss'],
})
export class BookingConfPage implements OnInit {
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  private common = CommonService;
  doctorId: any;
  appointmentTypeId: any;
  isDiss: any;
  presentView: string;
  bookingConf: boolean;
  firstBooking: boolean;
  reschedule: boolean;
  patientName: any;
  clinicId: any;
  vendor_name: any;
  amount: any;
  clinicLocation: any;
  clinicName: any;
  bookDate: string;
  fromTime: any;
  toTime: any;
  serviceTypeId: any;
  isVip: any = 0;
  bookingId: any;
  getDoctorProfile: any;
  toastMessage: any;
  selectedMemberId: any = "";
  partDocDet = [];
  serviceCost: any;
  totalCost: any;
  dealOpt: any;
  dealAmt: any;
  reschDate: any;
  reschFTym: any;
  reschTTym: any;
  searchCont: any;
  Gender: any;
  specialityname: any;
  specialityId: any;
  Email: any;
  Phoneno: any; referalId: any;
  paymentid: any;
  referenceid: any;
  paymentGatewayName: any;
  orderId: any;
  specialamt: any;
  specialdeal: any;
  BookedAmount: any;
  audio: any;
  ReAPServiceCost: any;
  userIP: any;
  isSlotDatas: any = [];
  SlotDetails: any;
  isConfirmed : boolean
  payType: any;
  gopayment: boolean = false;
  defaultImage = 'assets/img/Vector.png';
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';
  clinicAddress:any;
  clinicLatLong:any;
  LocationIcon: any;
  terms_and_condition_file: any;
  btnSubmit:any;

  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public loadingController: LoadingController,
    private datePipe: DatePipe,
    public toastController: ToastController,
    public ModalCtrl: ModalController,
    public popoverCtrl: PopoverController,
    private payment: Payment,
    public PopupalertPage: PopupalertPage,
    public addCall: AddCall,
    private httpClient: HttpClient,
    public geolocation: Geolocation,
    private platform: Platform,
    private file: File,
    private fileOpener: FileOpener
  ) { }

  ngOnInit() {
    this.payType = "";
    this.gopayment = false;
  }

  onImageErrors(event: Event,value:any): void {
    if(value == 'Male'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    }else if(value == 'Female'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
    else if(value == 'Vector'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.defaultImage;
    }
  }

  async presentToast() {
    const toast = await this.toastController.create({
      message: this.toastMessage,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Loading...',
    });
    await loading.present();
  }

  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "am" : "pm";
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  paymentType: any;
  alreadypaid: any;
  payOrRefund: any;
  reFundAmt: any;
  ionViewWillEnter() {
    this.btnSubmit = false;
    this.payType = ""
    this.gopayment = false
    this.payOrRefund = null;
    this.IpAddress();
    this.paymentType = this.activeRoute.snapshot.paramMap.get('paymenttype')
    console.log(this.paymentType);
    this.partDocDet = JSON.parse(window.localStorage['partDocDet']);
    console.log(this.partDocDet);
    this.amount = Number(this.common.doctorDetails.amount).toFixed(1);
    this.vendor_name = this.common.doctorDetails.vendor_name;
    this.presentView = "bookingConf";
    this.patientName = localStorage.getItem("patientName");
    if (localStorage.getItem("fromPage") == "newBooking" || localStorage.getItem("fromPage") == "newBookingDirectSlotClick") {
      console.log("come from first page");
      this.firstBooking = true;
      this.reschedule = false;
    }
    else if (localStorage.getItem("fromPage") == "reschedule") {
      console.log("come from Rescadule page");
      this.firstBooking = false;
      this.reschedule = true;
    }
    else {
      this.firstBooking = true;
      this.reschedule = false;
    }

    let scost = Number(window.localStorage['servCost']);
    let finalamount = Number(window.localStorage['finalamount']);
    this.reFundAmt = Number(window.localStorage['finalamount'])
    this.payOrRefund = String(window.localStorage['paydec']);
    this.alreadypaid = window.localStorage['alreadypaid'];
    console.log(window.localStorage['paydec']);
    console.log(Number(window.localStorage['finalamount']));
    console.log(scost, "che");

    if (scost <= 0) {
      this.serviceCost = 0;
    } else {
      this.serviceCost = scost;
    }

    let dopt = window.localStorage['dealOptn'];
    let damt = window.localStorage['dealAmt'];
    let dealAmt1;
    if (dopt == "Percentage") {
      this.dealOpt = " %";
      this.dealAmt = Number(damt);
      dealAmt1 = (Number(this.serviceCost) * Number(this.dealAmt)) / 100;
      if (this.reschedule == true && this.paymentType == 1 && this.payOrRefund == 'true') {
        dealAmt1 = (Number(finalamount) * Number(this.dealAmt)) / 100;
      }

    } else if (dopt == "Amount") {
      this.dealOpt = "KWD";
      this.dealAmt = Number(damt);
      dealAmt1 = Number(damt);
    } else {
      this.dealOpt = "";
      this.dealAmt = 0;
      dealAmt1 = 0;
    }
    let tcost = Number(this.serviceCost) - Number(dealAmt1);
    if (this.reschedule == true && this.paymentType == 1 && this.payOrRefund == 'true') {
      tcost = Number(finalamount) - Number(dealAmt1)
    }
    if (tcost <= 0) {
      this.totalCost = 0;
    } else {
      this.totalCost = tcost;
    }

    console.log(this.alreadypaid);
    console.log(this.payOrRefund);
    console.log("SUB", this.dealOpt);

    this.Gender = this.activeRoute.snapshot.paramMap.get('Gender');
    this.searchCont = this.activeRoute.snapshot.paramMap.get('searchCont');
    this.bookingId = this.activeRoute.snapshot.paramMap.get('bookingId');
    this.isVip = this.activeRoute.snapshot.paramMap.get('isVip');
    this.serviceTypeId = this.activeRoute.snapshot.paramMap.get('myServices');
    this.fromTime = this.activeRoute.snapshot.paramMap.get('fromTime');
    this.toTime = this.activeRoute.snapshot.paramMap.get('toTime');
    this.reschFTym = this.activeRoute.snapshot.paramMap.get('reschFTym');
    this.reschTTym = this.activeRoute.snapshot.paramMap.get('reschTTym');
    this.clinicId = this.activeRoute.snapshot.paramMap.get('clinicId');
    this.doctorId = this.activeRoute.snapshot.paramMap.get('doctorId');
    this.appointmentTypeId = this.activeRoute.snapshot.paramMap.get('appointmentTypeId');
    this.getDoctorProfile = this.activeRoute.snapshot.paramMap.get('doctorProfile');
    this.bookDate = this.activeRoute.snapshot.paramMap.get("bookDate");
    this.reschDate = this.activeRoute.snapshot.paramMap.get("reschDate");
    this.selectedMemberId = this.activeRoute.snapshot.paramMap.get("selectdMemId");
    this.specialityId = this.activeRoute.snapshot.paramMap.get('splid');
    this.specialityname = this.activeRoute.snapshot.paramMap.get('speciname');
    this.Email = ((this.activeRoute.snapshot.paramMap.get('email') != '') && (this.activeRoute.snapshot.paramMap.get('email') != null) && (this.activeRoute.snapshot.paramMap.get('email') != undefined)) ? this.activeRoute.snapshot.paramMap.get('email') : localStorage.getItem('Email');
    this.Phoneno = this.activeRoute.snapshot.paramMap.get('phone');
    this.specialamt = this.activeRoute.snapshot.paramMap.get('specialamount');
    this.BookedAmount = this.activeRoute.snapshot.paramMap.get('alreadyPaied');
    this.ReAPServiceCost = this.activeRoute.snapshot.paramMap.get('APServiceCost');
    this.specialdeal = this.activeRoute.snapshot.paramMap.get('specialdeal');
    this.isSlotDatas = this.activeRoute.snapshot.paramMap.get('isSlotDatas');
    this.patientName = this.activeRoute.snapshot.paramMap.get('patientName');
    this.clinicName = this.activeRoute.snapshot.paramMap.get('clinicName');
    this.clinicAddress = this.activeRoute.snapshot.paramMap.get('clinicAddress');
    this.clinicLatLong = this.activeRoute.snapshot.paramMap.get('clinicLatLong');
    this.LocationIcon = this.activeRoute.snapshot.paramMap.get('LocationIcon');
    console.log(this.specialityname, "=================spinamebookcf",this.LocationIcon);
    console.log(this.Email, this.Phoneno);
    this.referalId = this.activeRoute.snapshot.paramMap.get('referal_id') || "";
    if (this.specialdeal == 'percentage') {
      this.specialamt = Number(this.specialamt) * Number(this.totalCost) / 100
    } else if (this.specialdeal == 'amount') {
      this.specialamt = this.specialamt
    } else {
      this.specialamt = 0
    }
    console.log("From Time -> ", this.fromTime);
    console.log("To Time -> ", this.toTime);
    console.log("Book Date -> ", this.bookDate);
    this.appointmentTypeId == '2' ? this.isDiss = true : this.isDiss = false;
    debugger;
    if (this.platform.is("ios")) {
      try {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000
        };
        this.geolocation.getCurrentPosition(options).then((resp) => {
          this.LocationIcon = 'true';
          console.log("LocationIcon",this.LocationIcon, resp.coords.latitude, resp.coords.longitude);
        }, err => {
          this.LocationIcon = 'false';
          console.log('Error getting location', err,this.LocationIcon);
        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  backToDocAppointment(doctrId, clinicId) {

    if (this.reschedule == true) {
      this.serviceTypeId = window.localStorage["rescheduleServiceTypeId"]
    }
    this.isConfirmed = false
    this.router.navigate(['/tabs/doc-appointment', {
      doctorId: doctrId,
      appointmentTypeId: this.appointmentTypeId,
      clinicId: clinicId,
      fromTime: this.fromTime,
      toTime: this.toTime,
      reschFTym: this.reschFTym,
      reschTTym: this.reschTTym,
      patientName: this.patientName,
      serviceTypeId: this.serviceTypeId,
      searchDate: this.bookDate,
      reschDate: this.reschDate,
      bookingId: this.bookingId,
      selectdMemId: this.selectedMemberId ? this.selectedMemberId : "",
      searchCont: this.searchCont,
      Gender: this.Gender,
      paymenttype: this.paymentType,
      ServiceName: this.activeRoute.snapshot.paramMap.get("frmreschedule"),
      book_amount: this.alreadypaid,
      splid: this.specialityId,
    }]);
  }

  async Alertpopup(msg, status) {
    const alert = await this.ModalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    })
    alert.onDidDismiss()
      .then((res) => {
        if (res.data == 200) {
          this.router.navigate(['/tabs/home']);
        }
      })
    await alert.present()

  }

  async goToPayment(paySts) {
    if (paySts == 1) {
      if (this.appointmentTypeId != 2 && this.appointmentTypeId != 3) {
        console.log(this.appointmentTypeId);
        var cost = this.totalCost - this.specialamt;
      } else {
        cost = this.totalCost;
      }
      console.log(this.totalCost, this.specialamt);

      await this.presentModal1(paySts, cost);
    }
    else if (paySts == 2) {
      await this.presentModal1(paySts, this.totalCost);
    }
    else {
      this.btnSubmit = true;
      this.patientDoctorBooking(0, "");
    }
  }


  playSound() {
    let audio = new Audio();
    audio.src = "../assets/audio/tick.mp3";
    audio.load();
    audio.play();
  }

  gatewayFuction(res: any, paymentStatus: any, paymentGateway: any) {
    console.log(res[0], 'response', res);

    if (res.status == '1') {
      if (this.appointmentTypeId != 2 && this.appointmentTypeId != 3) {
        this.totalCost = this.totalCost - this.specialamt
      }
      this.paymentid = res.resultid;
      this.referenceid = res.sessionid;
      this.orderId = res.orderId;
      this.paymentGatewayName = res.paymentGatewayName;
      console.log(this.paymentid, '==', this.referenceid);
      if (this.reschedule == true) {
        this.rescheduleDoctorAppointment();
      }
      else {
        this.patientDoctorBooking(paymentStatus, res);
      }
    }
    else if(res.status == '2'){
      this.Alertpopup(this.addCall.title602, 0)
    }else{
      console.log('payment failed');
      if(paymentGateway=="KNET"){
        this.showKnetPaymentDetals(res, "Transaction Failed", this.addCall.title655);
      }else{
        this.Alertpopup(this.addCall.title602, 0)
      }
    }
  }

  gatewayFunctionReschedule(res: any, paymentGateway: any) {
    if (res.status == '1') {
      this.paymentid = res.resultid;
      this.referenceid = res.sessionid;
      this.orderId = res.orderId;
      this.paymentGatewayName = "MASTER CARD";
      console.log(this.paymentid, '==', this.referenceid);
      this.paymentType = 1;
      this.rescheduleDoctorAppointment();
    } else if(res.status == '2'){
      this.Alertpopup(this.addCall.title602, 0)
    }else {
      if(paymentGateway=="KNET"){
        this.showKnetPaymentDetals(res, "Transaction Failed", this.addCall.title655);
      }else {
        this.Alertpopup(this.addCall.title602, 0)
      }
    }
  }

  rescheduleIt() {
    console.log(this.patientName, this.Email, this.Phoneno, this.totalCost);
    if (this.totalCost > 0 || this.payOrRefund == 'false') {
      if (this.appointmentTypeId == 2 && this.paymentType == 0 || this.appointmentTypeId == 3 && this.paymentType == 0) {
        this.goToPayment(2)
      }
      else {
        this.rescheduleDoctorAppointment();
      }
    }
    else if (this.totalCost == 0) {
      if (this.appointmentTypeId == 2 && this.paymentType == 0 || this.appointmentTypeId == 3 && this.paymentType == 0) {
        this.goToPayment(2)
      }
      else {
        this.rescheduleDoctorAppointment();
      }
    }
  }

  IpAddress() {
    this.httpClient.get('https://jsonip.com').subscribe(
      (value: any) => {
        console.log(value);
        this.userIP = value.ip;
      },
      (error) => {
        console.log(error);
      }
    );
  }



  //API Integration.............
  async patientDoctorBooking(paySts, res) {

    let patientid;
    let isMember;
    if (this.selectedMemberId == "") {
      patientid = localStorage.getItem("patient_id");
      isMember = 0;
    }
    else {
      patientid = this.selectedMemberId;
      isMember = 1;
    }
    if (this.isVip == null || this.isVip == undefined || this.isVip == "" ||
      this.isVip == "null" || this.isVip == "undefined") {
      this.isVip = "0";
    }
    console.log("patientId=>", patientid);
    console.log("appMntTypeChangeabel=>", this.appointmentTypeId);

    const loading = await this.loadingController.create({
      message: 'Processing Your Payment Status',
    });
    await loading.present();
    const currentTimeUTC = new Date().toUTCString();
    console.log("Current UTC time:", currentTimeUTC);

    let now = new Date();
    let hours = now.getHours().toString().padStart(2, '0');
    let minutes = now.getMinutes().toString().padStart(2, '0');
    let seconds = now.getSeconds().toString().padStart(2, '0');

    let formattedTimeString = hours + ':' + minutes + ':' + seconds;
    console.log('time =', formattedTimeString);

    let requestdata = JSON.stringify({
      "doctorId": Number(this.doctorId),
      "patientId": patientid,
      "clinicId": this.clinicId,
      "serviceTypeId": this.serviceTypeId,
      "bookeDate": this.bookDate,
      "fromTime": this.fromTime,
      "toTime": this.toTime,
      "totalSlots": "1",
      "isVIP": this.isVip,
      "amount": this.totalCost,
      "paymentStatus": paySts,
      "appointmentTypeId": this.appointmentTypeId,
      "appointmentTypeIsChangable": 1,
      "isMember": isMember,
      "tempMemberName": this.patientName,
      "oldBookingId": "0",
      "booked_time": formattedTimeString,
      "dealId": window.localStorage['dealID'],
      "specialityId": this.specialityId,//this.splid,
      "specialityname": window.localStorage['speciname'],//this.specialityname,
      "paymentid": "", //this.paymentid,
      "referenceid": '',//this.referenceid,
      "paymentGateway": '',//this.paymentGatewayName,
      "serviceCost": this.serviceCost,
      "referal_id": this.referalId,
      "order_id": '',//this.orderId,
      "isAndroid": this.platform.is("ios") ? false : true,
      "ip_address": this.userIP
    });
    console.log("booking Data=>16", JSON.parse(requestdata));
    this.services.postRequest("patientDoctorBooking", requestdata).subscribe(async response => {

      console.log(response);
      await loading.dismiss();
      this.btnSubmit = false;
      if (response.status == 1) {
        this.isSlotBooked();
        setTimeout(() => {
          this.playSound();
        }, 1500)
        window.localStorage["storeNoOfApmnts"] = Number(window.localStorage["storeNoOfApmnts"]) + 1;
        localStorage.setItem("payBack", "doctors-list");

        if (paySts != '0' && localStorage.getItem("cardType") == "Knet") {
          this.showKnetPaymentDetals(res, paySts, this.addCall.title620);
        } else if (paySts == '0' || localStorage.getItem("cardType") == "MasterCard") {
          this.router.navigate(['payment', { paymentstatus: paySts }]);
        }
        console.log("booking");
      }
      else {
        console.log("not booking");
        localStorage.setItem("payBack", "booking-conf");
      }
    });
  }

  isSlotBooked() {

    console.log(this.isSlotDatas, "isSlotDatas");
    this.SlotDetails = this.isSlotDatas.split(',');
    let requestdata = JSON.stringify({
      "doctorId": this.SlotDetails[0],
      "patientId": localStorage.getItem("patient_id"),
      "clinicId": this.SlotDetails[1],
      "serviceId": this.SlotDetails[2],
      "bookingDate": this.SlotDetails[3],
      "fromTime": this.SlotDetails[4],
      "toTime": this.SlotDetails[5],
      "dayId": this.SlotDetails[6],
      "appointtypeId": this.SlotDetails[7],
      "paymentStatus": 1,
    });
    this.services.postRequest("isSlotBooked", requestdata).subscribe(response => {
      if (response.status == 1) {
        console.log(response,"isSlotBooked");
       }
    });
  }
  async showaddress(address, myEvent) {
    console.log('checkout address');
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: "doctorBKFC"
      },
      translucent: true,
      cssClass: 'offrMod'
    });
    popover.onDidDismiss()
    return await popover.present();
  }

  async rescheduleDoctorAppointment() {
    console.log(this.specialityname, "reschedule splname");
    let isMember;
    if (this.selectedMemberId == "") {
      isMember = 0;
    }
    else {
      isMember = 1;
    }
    if (this.isVip == null || this.isVip == undefined || this.isVip == "" ||
      this.isVip == "null" || this.isVip == "undefined") {
      this.isVip = "0";
    }

    const loading = await this.loadingController.create({
      message: 'Loading...',
    });
    await loading.present();
    const currentTimeUTC = new Date().toUTCString();
    console.log("Current UTC time:", currentTimeUTC);

    let now = new Date();
    let hours = now.getHours().toString().padStart(2, '0');
    let minutes = now.getMinutes().toString().padStart(2, '0');
    let seconds = now.getSeconds().toString().padStart(2, '0');

    let formattedTimeStrings = hours + ':' + minutes + ':' + seconds;
    console.log('time =', formattedTimeStrings);

    let requestdata = JSON.stringify({
      "oldBookingId": this.bookingId,
      "doctorId": Number(this.doctorId),
      "patientId": localStorage.getItem("reschedulePatientId"),
      "clinicId": this.clinicId,
      "serviceTypeId": this.serviceTypeId,
      "bookeDate": this.bookDate,
      "fromTime": this.fromTime,
      "toTime": this.toTime,
      "totalSlots": "1",
      "isVIP": this.isVip,
      "amount": this.BookedAmount,
      "paymentStatus": this.paymentType,
      "appointmentTypeId": Number(this.appointmentTypeId),
      "appointmentTypeIsChangable": 1,
      "isMember": isMember,
      "tempMemberName": this.patientName,
      "booked_time": formattedTimeStrings,
      "specialityId": this.specialityId,//this.splid,
      "specialityname": this.specialityname,
      "paymentid": this.paymentid,
      "order_id": this.orderId,
      "referenceid": this.referenceid,
      "paymentGateway": this.paymentGatewayName,
      "ReAPServiceCost": this.ReAPServiceCost,
    });
    this.services.postRequest("rescheduleDoctorAppointment", requestdata).subscribe(async response => {
      console.log(response);
      await loading.dismiss();
      if (response.status == 1) {
        this.Alertpopup(this.addCall.title446, 1);
      }
      else {
        console.log("not booking");
        this.Alertpopup(response.msg, 2);
      }
    });
  }



  setTime() {
    if (this.reschedule) {
      if (this.addCall.selectedLanguage == 'en') {
        return this.getFormattedDateTime(this.reschFTym, "Time") + " to " + this.getFormattedDateTime(this.reschTTym, "Time");
      } else if (this.addCall.selectedLanguage == 'ea') {
        return this.getFormattedDateTime(this.reschTTym, "Time") + " - " + this.getFormattedDateTime(this.reschFTym, "Time");
      }
    } else {
      if (this.addCall.selectedLanguage == 'en') {
        return this.getFormattedDateTime(this.fromTime, "Time") + " to " + this.getFormattedDateTime(this.toTime, "Time");
      } else if (this.addCall.selectedLanguage == 'ea') {
        return this.getFormattedDateTime(this.toTime, "Time") + " - " + this.getFormattedDateTime(this.fromTime, "Time");
      }

    }
  }

  async presentModal1(paySts, cost) {
    const modal = await this.ModalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: "pay",
      }
    });
    modal.onDidDismiss().then(async (data) => {

      console.log("data", data);
      this.gopayment = true;
      this.payType = data.data;
      if (paySts == 1) {
        const loading = await this.loadingController.create({
          message: 'Please wait we are redirecting you to the payment gateway',
        });
        if (data.data == "1" && this.gopayment) {
          this.gopayment = false;
          await loading.present();
          this.payment.getsessionid(this.patientName, this.Email, this.Phoneno, cost).then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFuction(res, paySts, "MASTER");
          });
        } else if (data.data == "2" && this.gopayment) {
          this.gopayment = false;
          await loading.present();
          this.payment.getKnetsessionid("", this.Email, this.Phoneno, cost).then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFuction(res, paySts, "KNET");
          });
        }
        // else if (data.data == "3" && this.gopayment) {
        //   this.gopayment = false;
        //   await loading.present();
        //   this.payment.getApplesessionid(this.patientName, this.Email, this.Phoneno, cost).then(async (res: any) => {
        //     await loading.dismiss();
        //     this.gatewayFuction(res, paySts, "APPLE PAY");
        //   });
        // }
      } else if (paySts == 2) {
        const loading = await this.loadingController.create({
          message: 'Please wait we are redirecting you to the payment gateway',
        });
        if (data.data == "1" && this.gopayment) {
          this.gopayment = false;
          this.payment.getsessionid(this.patientName, this.Email, this.Phoneno, cost).then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunctionReschedule(res, "MASTER");
          });
        } else if (data.data == "2" && this.gopayment) {
          this.gopayment = false;
          this.payment.getKnetsessionid("", this.Email, this.Phoneno, cost).then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunctionReschedule(res, "KNET");
          });
        }
        // else if (data.data == "3" && this.gopayment) {
        //   this.gopayment = false;
        //   await loading.present();
        //   this.payment.getApplesessionid(this.patientName, this.Email, this.Phoneno, cost).then(async (res: any) => {
        //     await loading.dismiss();
        //     this.gatewayFunctionReschedule(res, paySts);
        //   });
        // }
      }
      this.payType = "";
      this.gopayment = false
    })
    return await modal.present();

  }

  async showKnetPaymentDetals(data: any, paySts: any, msg: string) {
    const modal = await this.ModalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'Bookingappoinments',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      }
    });

    modal.onDidDismiss().then(async (data) => {
      if(msg == this.addCall.title620){
        this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }


  async OpenMapMethod() {
    const modal = await this.ModalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: this.clinicName,
        clinic_address: this.clinicAddress,
        clinic_lat_long: this.clinicLatLong,
      }
    });
    modal.onDidDismiss()
    .then((data) => {
      if (data.data == "Map_Not_Show") {
         this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }



  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Doctor');

    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);

            if (!decryptedData) {
              throw new Error('Decryption failed');
            }

            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);

            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }

            const documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on =  new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {

                const modified_on =  new Date();

                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                const localBlob = new Blob([blob], { type: 'application/pdf' });
                const fileName = `report_${new Date().getTime()}.pdf`;
                await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                  .then((fileEntry) => {
                    console.log("File entry:", fileEntry);
                    this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                      .then(() => console.log('File is opened'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(e => console.log('Error writing file', e));
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });

          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }


}
